export { EventManager as default, preventDefault, stopPropagation, stopEvent } from 'choerodon-ui/dataset';
